import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject, Renderer2, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-dropdown-cell-editor',
  standalone: true,
  imports: [NgSelectModule, CommonModule, FormsModule],
  templateUrl: './dropdown-cell-editor.component.html',
  styleUrl: './dropdown-cell-editor.component.scss'
})
export class DropdownCellEditorComponent implements ICellEditorAngularComp {
  params: any;
  options: any[] = [];
  selectedValue: any;

  @ViewChild('dropdown') dropdown!: NgSelectComponent;

  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  agInit(params: any): void {
    this.params = params;
    this.options = params.options || [];
    this.selectedValue = params.value;

    const width = (this.el.nativeElement as HTMLElement).offsetWidth + 'px';
    document.body.style.setProperty('--dropdown-width', width);
  }

  getValue() {
    return this.selectedValue;
  }

  afterGuiAttached?(): void {
    setTimeout(() => {
      this.dropdown.focus();
    });
  }

  onChange(value: any) {
    this.selectedValue = value;

    setTimeout(() => {
      this.dropdown.blur(); // remove focus visually
      this.params.api.stopEditing(); // tell AG Grid editing is done
    }, 100);
  }
}
